import React from 'react';
import { Button } from 'reactstrap';

const columns = ({
  setRaiseDetailsData,
  setIsRaiseDetailsOpen,
  handleApprove,
  handleRepprove,
}: {
  setRaiseDetailsData: any;
  setIsRaiseDetailsOpen: any;
  handleApprove: (id: string) => void;
  handleRepprove: (id: string) => void;
}) => {
  return [
    {
      name: 'Name',
      grow: 2,
      cell: (row: any) => (
        <div
          className="d-flex align-items-center"
          style={{
            cursor: 'pointer',
            transition: 'filter 0.3s ease',
            filter: 'brightness(1)',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.filter = 'brightness(0.8)')}
          onMouseLeave={(e) => (e.currentTarget.style.filter = 'brightness(1)')}
          onClick={() => {
            setRaiseDetailsData(row);
            setIsRaiseDetailsOpen(true);
          }}
        >
          <div style={{ width: '35px', height: '35px', borderRadius: '50%', overflow: 'hidden', flexShrink: 0 }}>
            <img
              src={row.user.picture}
              alt="User Profile"
              className="img-fluid"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </div>
          <span className="ml-2 text-primary font-weight-bold text-sm">{`${row.user.firstName || '-'} ${
            row.user.lastName || '-'
          }`}</span>
        </div>
      ),
    },
    {
      name: 'Status',
      selector: (row: any) => row.status,
      grow: 1,
      cell: (row: any) => (
        <>
          {row.status === 'PENDDING' && (
            <div style={{ border: '1px solid #d4d110', padding: '4px 8px', borderRadius: '3px' }}>
              <span style={{ color: '#d4d110', fontWeight: '700' }}>REQUESTED</span>
            </div>
          )}

          {row.status === 'REPPROVE' && (
            <div style={{ border: '1px solid #d43710', padding: '4px 8px', borderRadius: '3px' }}>
              <span style={{ color: '#d43710', fontWeight: '700' }}>DENIED</span>
            </div>
          )}

          {row.status === 'APPROVE' && (
            <div style={{ border: '1px solid #08b408', padding: '4px 8px', borderRadius: '3px' }}>
              <span style={{ color: '#08b408', fontWeight: '700' }}>APPROVED</span>
            </div>
          )}
        </>
      ),
    },
    {
      name: 'Current Pay Rate',
      selector: (row: any) => (row.oldAmount ? `$ ${parseFloat(row.oldAmount).toFixed(2)}` : ''),
      grow: 1,
      cell: (row: any) => (row.oldAmount ? `$ ${parseFloat(row.oldAmount).toFixed(2)}` : ''),
    },
    {
      name: 'Raise Amount',
      selector: (row: any) => (row.amount ? `$ ${parseFloat(row.amount).toFixed(2)}` : ''),
      grow: 1,
      cell: (row: any) => (row.amount ? `$ ${parseFloat(row.amount).toFixed(2)}` : ''),
    },
    {
      name: '% Increase',
      selector: (row: any) => (((row.amount - row.oldAmount) / row.oldAmount) * 100).toFixed(2) + ' %',
      grow: 1,
      cell: (row: any) => (((row.amount - row.oldAmount) / row.oldAmount) * 100).toFixed(2) + ' %',
    },
    {
      name: 'Reason',
      selector: (row: any) => row.reason,
      grow: 1,
      cell: (row: any) => row.reason,
    },
    {
      name: 'Actions',
      selector: (row: any) => row.supervisor.name,
      grow: 1,
      cell: (row: any) => (
        <div className="d-flex" style={{ gap: '5px' }}>
          {row.status === 'PENDDING' && (
            <>
              <Button
                style={{
                  border: 'none',
                  boxShadow: 'none',
                  background: '#FFFFFF',
                  padding: 0,
                }}
                onClick={() => handleApprove(row.id)}
              >
                <i className="fas fa-check" />
              </Button>
              <Button
                style={{
                  border: 'none',
                  boxShadow: 'none',
                  background: '#FFFFFF',
                  padding: 0,
                }}
                onClick={() => handleRepprove(row.id)}
              >
                <i className="fas fa-ban" />
              </Button>
            </>
          )}

          <Button
            style={{
              border: 'none',
              boxShadow: 'none',
              background: '#FFFFFF',
              padding: 0,
            }}
            onClick={() => {
              setRaiseDetailsData(row);
              setIsRaiseDetailsOpen(true);
            }}
          >
            <i className="fas fa-eye" />
          </Button>
        </div>
      ),
    },
  ];
};

export default columns;
